import $ from 'jquery'
import Swiper, { Navigation, Lazy } from 'swiper'

const observer = 'IntersectionObserver' in window
  ? new IntersectionObserver(function(entries, obs) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) {
          return
        }
        obs.unobserve(entry.target)
        const init = $(entry.target).data('cardGalleryInit')
        if (typeof init === 'function') {
          init()
        }
      })
    }, { rootMargin: '200px 0px' })
  : null

/* Une seule carte naviguée à la fois */
const RESET_DELAY = 8000

let active = null,
    resetTimer = null

const release = function(swiper, speed) {
  if (active === swiper) {
    active = null
    clearTimeout(resetTimer)
    if (leaveObserver) {
      leaveObserver.unobserve(swiper.el)
    }
  }
  if (!swiper.destroyed && swiper.realIndex !== 0) {
    swiper.slideToLoop(0, speed)
  }
}

const leaveObserver = 'IntersectionObserver' in window
  ? new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting && active && active.el === entry.target) {
          release(active, 0)
        }
      })
    })
  : null

const onSlideChange = function(swiper) {
  if (swiper.realIndex === 0) {
    if (active === swiper) {
      release(swiper)
    }
    return
  }
  if (active !== swiper) {
    const previous = active
    active = swiper
    if (previous) {
      release(previous)
    }
    if (leaveObserver) {
      leaveObserver.observe(swiper.el)
    }
  }
  clearTimeout(resetTimer)
  resetTimer = setTimeout(function() {
    release(swiper)
  }, RESET_DELAY)
}

$.fn.CardGallery = function() {
  return this.each(function() {
    let $picture = $(this)

    if ($picture.data('cardGallery')) {
      return
    }

    let $slider = $picture.find('.product-list__slider'),
        $slides = $picture.find('.product-list__slide')

    if (!$slider.length || $slides.length < 2) {
      return
    }

    const init = function() {
      if ($picture.data('cardGallery')) {
        return
      }
      $picture.data('cardGallery', true)

      const swiper = new Swiper($slider.get(0), {
        modules: [ Navigation, Lazy ],
        loop: true,
        slidesPerView: 1,
        spaceBetween: 1,
        threshold: 8,
        // Sinon le geste n'est capté que sur le wrapper, et glisser depuis un
        // chevron — près de la moitié de la largeur sur téléphone — ne fait rien.
        touchEventsTarget: 'container',
        preloadImages: false,
        lazy: {
          enabled: true,
          loadPrevNext: true,
        },
        navigation: {
          enabled: true,
          prevEl: $picture.find('.product-list__slide-nav--prev').get(0),
          nextEl: $picture.find('.product-list__slide-nav--next').get(0),
        },
        on: {
          slideChange: onSlideChange,
        },
      })

      $picture.addClass('product-list__picture--gallery-ready').data('cardGallerySwiper', swiper)
    }

    $picture.data('cardGalleryInit', init)

    if (observer) {
      observer.observe(this)
    } else {
      init()
    }

    $picture.on('mouseenter.cardGallery touchstart.cardGallery', init)

    $picture.on('click.cardGallery keydown.cardGallery', '.product-list__slide-nav', function(e) {
      if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') {
        return
      }
      e.preventDefault()
      e.stopPropagation()
    })
  })
}
